const React = require('react');
const { joiResolver } = require('@hookform/resolvers/joi');
const FormFieldUtils = require('./formFieldUtils');

const FormHookUtils = module.exports = {};

FormHookUtils.buildUseFormOptions = ({
    formOptions = {},
    processedDefaults,
    resolver,
    schema
}) => ({
    mode: 'onChange',
    ...formOptions,
    defaultValues: processedDefaults,
    ...(resolver || schema ? {
        resolver: resolver || joiResolver(schema)
    } : {})
});

FormHookUtils.buildFormModel = ({
    fields,
    methods
}) => ({
    defaults: methods?.control?._defaultValues || {},
    fields
});

FormHookUtils.buildFieldProviderConfig = ({
    fields,
    formId
}) => ({
    formId,
    getFieldDefinition: (fieldName) => FormFieldUtils.getFieldDefinition({
        fieldName,
        fields
    })
});

FormHookUtils.buildFormProps = ({
    formId,
    submitHandler
}) => ({
    id: formId,
    noValidate: true,
    onSubmit: submitHandler
});

FormHookUtils.buildRenderForm = ({
    FormProvider,
    formProps,
    methods
}) => (children, extraFormProps = {}) => <FormProvider {...methods}>
    <form
        {...formProps}
        {...extraFormProps}
    >
        {children}
    </form>
</FormProvider>;